import React from 'react';

import documentStyles from 'components/Document/Document.module.scss';
import { HFS_PRIVACY_POLICY_URL } from 'constants/constants';
import styles from 'pages/PreQualification/steps/ContractorInfo/AgreementPopup/AgreementPopup.module.scss';

const AcceptTermsOfUse = () => {
  return (
    <>
      <p className={styles.title}>Consent to Proceed</p>
      <div className={styles.agreementText}>
        <p className={documentStyles.title}>CONSENT:</p>
        <p className={documentStyles.title}>ELECTRONIC SIGNATURES, RECORDS, AND DISCLOSURES:</p>
        <p className={documentStyles.bodyText}>
          Please read this information carefully and print a copy and/or retain this information for future reference.
          You are submitting a request to be matched with one of our third-party lenders. In order to offer you a loan
          from a participating lender, the lenders need your consent to use and accept electronic signatures, records,
          and disclosures. This disclosure notifies you of your rights when receiving electronic disclosures, notices,
          and information. By clicking to accept, you acknowledge that you received this consent and that you consent to
          conduct transactions using electronic signatures, electronic disclosures, electronic records, and electronic
          contract documents (“Disclosures”).
        </p>
        <p className={documentStyles.title}>OPTION FOR PAPER OR NON-ELECTRONIC RECORDS:</p>
        <p className={documentStyles.bodyText}>
          You may request any Disclosures in paper copy by contacting the third-party lender directly. The participating
          lender will provide paper copies at no charge. The participating lender will retain all Disclosures as
          applicable law requires.
        </p>
        <p className={documentStyles.title}>SCOPE OF CONSENT:</p>
        <p className={documentStyles.bodyText}>
          This consent applies to all interactions online concerning you and the third-party lender and includes those
          interactions engaged in on any mobile device, including phones, smart-phones, and tablets. By agreeing to this
          consent, the third-party lender may process your information and interact during all online interactions with
          you electronically. The lender may also send you electronic Disclosures, including by email.
        </p>
        <p className={documentStyles.title}>HARDWARE AND SOFTWARE REQUIREMENTS:</p>
        <p className={documentStyles.bodyText}>
          To access and retain the Disclosures electronically, you will need to use the following computer software and
          hardware: A PC or MAC compatible computer or other device capable of accessing the Internet, access to an
          e-mail account, and an Internet Browser software program that supports at least 128 bit encryption, such as
          Microsoft® Edge, Mozilla Firefox®, Google Chrome™ or Safari®. To read some documents, you may need a PDF
          file reader like Adobe® Acrobat Reader X ® or Foxit®. You will need a printer or a long-term storage
          device, such as your computer’s disk drive, to retain a copy of the Disclosures for future reference. You may
          direct questions regarding the hardware and software requirements directly to the third party lenders.
        </p>
        <p className={documentStyles.title}>WITHDRAWING CONSENT:</p>
        <p className={documentStyles.bodyText}>
          Your E-Consent for our matching service and for our third-party lenders’ consideration of your matching
          request cannot be withdrawn because it is a one-time transaction. If you are matched with one or more
          third-party lenders, you are free to withdraw your consent with those third-party lenders at any time and at
          no charge. However, if you withdraw this consent before receiving credit from a participating lender, you may
          be prevented from obtaining credit from such lender. Contact the third-party lender directly if you wish to
          withdraw this consent. If you decide to withdraw this consent, the legal effectiveness, validity, and
          enforceability of prior electronic Disclosures will not be affected.
        </p>
        <p className={documentStyles.title}>YOUR ABILITY TO ACCESS DISCLOSURES:</p>
        <p className={documentStyles.bodyText}>
          By clicking to accept, you confirm that you can access the disclosures in the designated formats described
          above.
        </p>
        <p className={documentStyles.title}>CALL MONITORING AND RECORDING; FRAUD PREVENTION:</p>
        <p className={documentStyles.bodyText}>
          You consent to call monitoring and recording, for purposes that include but are not limited to training,
          quality assurance, and/or risk management, of any call between you and Company. You authorize your wireless
          carrier to use or disclose information about your account and your wireless device, if available, to Company
          or its service providers for the duration of your business relationship with Company, solely to help them
          identify you or your wireless device and to prevent fraud. See our Privacy Policy for how we treat your data,
          available{' '}
          <a href={HFS_PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
            HERE
          </a>
          .
        </p>
        <p className={documentStyles.title}>CREDIT UNION DISCLOSURE:</p>
        <p className={documentStyles.bodyText}>
          If you wish to accept a loan offer from a participating lender that is a credit union, you must become a
          member of the credit union, and, therefore, certain membership requirements (including the opening of a share
          account and any applicable association fees in connection with membership) may apply.
        </p>
        <p className={documentStyles.title}>INFORMATION SHARING/CONTACT AUTHORIZATION:</p>
        <p className={documentStyles.bodyText}>
          You are submitting information to Company for the purpose of obtaining assistance from Company in potentially
          securing a swimming pool or home improvement loan from a participating lender. In connection with your
          inquiry, you authorize Company to share your information with such potential lenders and/or their affiliates,
          agents, brokers, and/or partners (including any third-party home improvement contractor or lead generation
          source/service provider related to your inquiry). Company may update these parties concerning your loan
          inquiry and the related loan status. You also agree that a participating lender that extends credit to you as
          a result of Company’s introduction is authorized to share information concerning loan performance with
          Company, from time to time. By voluntarily providing Company with your phone numbers and/or email addresses,
          you expressly authorize Company and/or participating lenders to communicate with you regarding your inquiry at
          the phone numbers (including mobile device numbers) and email addresses you provide, including through the use
          of automated dialing/messaging systems and/or pre-recorded voice messages.
        </p>
        <p className={documentStyles.title}>CORRECT INFORMATION; CREDIT REVIEW:</p>
        <p className={documentStyles.bodyText}>
          You certify that all of the information provided in your inquiry is true and correct, and you are confirming
          you have read and understand all Company terms. You are providing written instructions to Company under the
          Fair Credit Reporting Act authorizing Company to obtain information from your personal credit profile or other
          information from one or more credit reporting agencies or other sources now and from time to time to best
          match you with one or more participating lenders, to offer you additional products/services in the future,
          and/or to improve the services we offer. You agree that Company may share such credit information with
          participating lenders. You further authorize affiliates, agents, brokers, lenders, servicers, and successors
          and/or assignees to notify Company about a participating lender's decision to approve or deny your loan, which
          may include your loan terms, application status, unique loan ID, and other personally identifiable
          information.
        </p>
        <p className={documentStyles.bold}>
          BY CLICKING TO ACCEPT, YOU ACKNOWLEDGE YOU HAVE READ THE INFORMATION ABOUT ELECTRONIC SIGNATURES/DISCLOSURES
          AND DOING BUSINESS ELECTRONICALLY AND YOU CONSENT TO USING ELECTRONIC SIGNATURES/DISCLOSURES AND ALL OTHER
          TERMS PROVIDED ABOVE.
        </p>
      </div>
    </>
  );
};

export default AcceptTermsOfUse;
